import React from 'react';
import { Typography, Box, Card, Chip } from '@material-ui/core';
import TrendingUpRoundedIcon from '@material-ui/icons/TrendingUpRounded';

const ApplicationsActivityCard = ({ applications }) => {
    return (
        <Card elevation={0} className="whats-new-modules-card">
            <Box className="whats-new-modules-header">
                <TrendingUpRoundedIcon />
                <Typography className="whats-new-modules-title">Applications updated</Typography>
                <Typography className="whats-new-modules-subtitle">Last 90 days</Typography>
            </Box>
            {applications.map(application => (
                <Box key={application.name} className="whats-new-module-row" style={{ '--module-color': application.color, '--module-tint': `${application.color}12` }}>
                    <Box className="whats-new-module-avatar">{application.name.charAt(0)}</Box>
                    <Typography className="whats-new-module-name">{application.name}</Typography>
                    <Chip label={application.count} size="small" className="whats-new-module-count" />
                </Box>
            ))}
        </Card>
    )
};

export default ApplicationsActivityCard;